var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.visible)?_c('div',{staticClass:"modal-mask px-2 sm:px-4 sidebar:px-6 fixed pin w-full h-full flex justify-between items-center"},[_c('div',{staticClass:"modal-container mx-auto flex flex-col rounded bg-white w-full shadow-lg"},[_c(_vm.component,{tag:"component"})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }